import React, { useState } from 'react';
import { inject, observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControlLabel, Grid, Typography } from '@material-ui/core';

import CustomRadio from '../../button/CustomRadio';
import { CustomButton } from '../../button';
import { IconNotice } from '../../../static/images/icon';
import { PAY_ITEMS } from './PayBox';
import { PayMethodPreview } from '../../payment';

// 결제구분(모바일) — 선불 · 착불 · 신용. 접수 버튼을 누르면 인성에 바로 접수된다
const useStyles = makeStyles((theme) => ({
  title: {
    paddingBottom: 30,
  },
  radioTitle: {
    lineHeight: 1.2
  },
  marginB: {
    marginBottom: 10,
  },
  succesBtn: {
    marginTop: 30,
  },
  noticeImg: {
    marginLeft: 5,
    marginTop: 5,
    width: 20
  }
}));

function PayBoxM({ qsStore, pageType }) {
  const cs = useStyles();
  const { quickerReg, handleOptions, options, submitting } = qsStore;
  const [payGbn, setPayGbn] = useState(options.payGbn || '1');

  const handleChange = (e) => {
    const value = e.target.value;
    setPayGbn(value);
    handleOptions('payGbn', value);
  }

  return (
    <Grid className={cs.root} container direction="column" justify="flex-start" alignItems="flex-start">
      <Grid className={cs.title} container direction="column" justify="center" alignItems="center">
        <Typography variant="body1" color="primary">
          <b>결제구분</b>
        </Typography>
      </Grid>
      <Grid container>
        {PAY_ITEMS.map((item) => (
          <Grid key={item.value} className={cs.marginB} item xs={4}>
            <FormControlLabel
              value={item.value}
              control={<CustomRadio name="payGbn" checked={payGbn === item.value} onChange={handleChange} />}
              label={
                <Typography className={cs.radioTitle} variant="body2" color="textPrimary">
                  <b>{item.title}</b>
                </Typography>
              }
              classes={{ label: 'label' }}
              style={{ marginRight: 10 }}
            />
          </Grid>
        ))}
      </Grid>
      <PayMethodPreview dense />
      <CustomButton
        className={cs.succesBtn}
        fullWidth
        variant="contained"
        color="primary"
        disabled={submitting}
        onClick={() => quickerReg(pageType)}
      >{submitting ? '접수 중' : '접수/예약완료'}</CustomButton>
      <Grid container direction="row" justify="flex-start" alignItems="flex-start" style={{ marginTop: 10 }}>
        <img alt="" className={cs.noticeImg} style={{ marginRight: 10 }} src={IconNotice} />
        <Typography variant="caption" color="primary">
          선택정보 외 추가 사항이 발생할 경우 추가요금이<br></br> 발생됩니다.
        </Typography>
      </Grid>
    </Grid>
  );
}

export default inject('qsStore')(observer(PayBoxM));
